import { render, staticRenderFns } from "./addCommanderDialog.vue?vue&type=template&id=6abcc516&scoped=true"
import script from "./addCommanderDialog.vue?vue&type=script&lang=js"
export * from "./addCommanderDialog.vue?vue&type=script&lang=js"
import style0 from "./addCommanderDialog.vue?vue&type=style&index=0&id=6abcc516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abcc516",
  null
  
)

export default component.exports